import * as React from 'react'

import {
  getPatientBirthSexLabel,
  getPatientBirthSexShortLabel,
} from '../patient.helpers'

import type { IPatient } from '../patient.interface'

interface Props {
  className?: string
  fallbackLabel?: string
  patient: IPatient
  shortForm?: boolean
}

const DEFAULT_FALLBACK_LABEL = '–'

const PatientBirthSex = function ({
  className,
  fallbackLabel,
  patient,
  shortForm,
}: Props) {
  const value = React.useMemo(
    () =>
      patient.birthSex
        ? shortForm
          ? getPatientBirthSexShortLabel(patient)
          : getPatientBirthSexLabel(patient)
        : fallbackLabel || DEFAULT_FALLBACK_LABEL,
    [patient, fallbackLabel, shortForm],
  )
  return <span className={className}>{value}</span>
}

export { PatientBirthSex }
